import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import classNames from "classnames";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { PipelineConfig } from "../../../interfaces/doc";
import FormSelectField from "../../Common/FormSelectField";
import { filterClassificationQueries } from "./ResultFormUtils";

const ClassificationForm: React.FC<{ config: PipelineConfig }> = ({
  config,
}) => {
  const { control } = useFormContext();
  const split = useWatch({ name: "classification.split" });

  return (
    <div className="flex flex-col gap-1 w-full">
      <Typography
        component="div"
        className={classNames("font-semibold flex items-center mb-2")}
      >
        Classifications
      </Typography>

      {!!config.split && (
        <FormSelectField
          name={`classification.split`}
          options={[
            ...config.split.segmentation.classes.map((classe) => classe.name),
            ...(config.split.segmentation.default
              ? [config.split.segmentation.default.name]
              : []),
          ]}
          control={control}
        />
      )}
      {!!config.classification &&
        filterClassificationQueries(config.classification.queries, split).map(
          (query) => (
            <Controller
              key={query.name}
              render={({ field: { onChange, ...props } }) => (
                <Autocomplete
                  options={[
                    ...query.classes.map((classe) => classe.name),
                    ...(query.default ? [query.default.name] : []),
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                  onChange={(e, lang) => onChange(lang)}
                  {...props}
                />
              )}
              name={`classification.${query.name}`}
              control={control}
            />
          )
        )}
    </div>
  );
};

export default ClassificationForm;
